'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FormFieldError = require('wix-ui-icons-common/system/FormFieldError');

var _FormFieldError2 = _interopRequireDefault(_FormFieldError);

var _Tooltip = require('../Tooltip');

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _InputArea = require('./InputArea.scss');

var _InputArea2 = _interopRequireDefault(_InputArea);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Exclamation = function Exclamation(_ref) {
  var errorMessage = _ref.errorMessage,
      tooltipPlacement = _ref.tooltipPlacement,
      onTooltipShow = _ref.onTooltipShow;
  return _react2.default.createElement(
    'div',
    { className: _InputArea2.default.suffix },
    _react2.default.createElement(
      _Tooltip2.default,
      {
        dataHook: 'inputArea-tooltip',
        disabled: errorMessage.length === 0,
        placement: tooltipPlacement,
        onShow: onTooltipShow,
        alignment: 'center',
        hideDelay: 100,
        content: errorMessage,
        moveBy: { x: 0, y: -10 },
        overlay: '',
        maxWidth: '250px',
        textAlign: 'left',
        theme: 'dark'
      },
      _react2.default.createElement(
        'div',
        { className: _InputArea2.default.errorIcon },
        _react2.default.createElement(_FormFieldError2.default, null)
      )
    )
  );
};

Exclamation.defaultProps = {
  errorMessage: '',
  tooltipPlacement: 'top'
};

Exclamation.propTypes = {
  errorMessage: _propTypes2.default.string,
  tooltipPlacement: _propTypes2.default.oneOf(['right', 'left', 'top', 'bottom']),
  onTooltipShow: _propTypes2.default.func
};

exports.default = Exclamation;